<template>
    <div>  
         <div class="news-live widget" v-if="news.length > 0">
            <div class="widget-title" :style="{background:feedData.color}">
                <img :alt="$t('home.widget.feed.'+feedData.type+'.text')" :src="feedData.icon"/> 
                {{ $t("home.widget.feed."+feedData.type+".text") }}
            </div>
            <ul>
                <li v-for="item in news" :key="item.message">
                    <article>
                        <a :href="item.link" target="_blank">
                            <table>
                                <tr>
                                    <td class="time" :style="{background:feedData.color}">{{item.pubDate | formatHour}}</td>
                                    <td class="article-title">{{item.title}}</td>
                                </tr>
                            </table>
                        </a>
                    </article>
                </li>
            </ul>
            <div class="loading" v-if="loading">
                <b-spinner label="Loading..."></b-spinner>
            </div>
         </div>
    </div>
</template>

<script>
    export default {
        name: "NewsLiveWidget",
        props: {
            news: Array,
            feedData: Object,
            loading: Boolean
        }
    }
</script>

<style scoped>
.widget {
    position: relative;
}
.news-live.widget {
    width: 100%;
    max-width: 400px;
    margin: auto;
}
.news-live.widget .widget-title {
    padding: 8px 15px;
    padding-left: 5px;
    position: relative;
    font-size: 20px;
    font-weight: bold;
    background:  #2459a0;
    color: #fff;
    display: flex;
    align-items: center;
    margin-bottom: 15px;
}
.news-live.widget .widget-title img {
    width: 45px;
    margin-right: 5px;
}
.news-live.widget li {
    clear: both;
    margin-bottom: 15px;
    display: flex;
    border-bottom: 1px solid #8f8f8f;
    padding-bottom: 15px;

}
.news-live.widget article {
    width: 100%;
}
.news-live.widget .article-title {
    color: #2459a0;
    font-size: 18px;
    font-weight: 500;
    vertical-align: middle;
}
.news-live.widget .time {
    color: #fff;
    float: left;
    margin-right: 15px;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}

#widget .loading {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
  } 
</style>

